import { ActionType } from 'typesafe-actions';

import * as TripsOldActions from 'store/actions/tripsOld';
import { TripsOldResponse } from 'store/types/reports';
import { call, put, takeEvery } from 'redux-saga/effects';
import { rejectPromiseAction, resolvePromiseAction } from 'redux-saga-promise-actions';
import Endpoints from 'endpoints';
import GipsyyGDSApi from 'apis/GipsyGDS';

function* getTripsOld(action: ActionType<typeof TripsOldActions.getTripsOld.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);

  try {
    const response: { data: any } = yield GipsyyGDSApi.get(Endpoints.getTripsOld(), {
      params: action?.payload,
      headers: {
        Authorization: `bearer ${token}`,
      },
    });

    yield put(TripsOldActions.getTripsOld.success(response.data.data));
    yield call(resolvePromiseAction, action, response.data.data);
    yield response.data.data;
  } catch (error) {
    yield put(TripsOldActions.getTripsOld.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

export const watchTripsOld = [takeEvery(TripsOldActions.getTripsOld.request, getTripsOld)];
